import { BaseElement, ClickElement } from './base-element';
import { ElementType } from './element-type';

export class Wizard extends ClickElement {
  steps: Step[] = [];

  successTitle: string = '';

  successMessage: string = '';

  nextText: string = '';

  backText: string = '';

  sendText: string = '';

  step: number = 0;

  maxFileUploadSize: number | null = null;

  constructor() {
    super();
    this.elementType = ElementType.wizard;
  }
}

export class Step extends BaseElement {
  title: string = '';
}
